var map = {
	"./arrow-bottom.svg": 7446,
	"./arrow-top.svg": 5644,
	"./arrow-white.svg": 8210,
	"./arrow.svg": 7190,
	"./big-arrow-green.svg": 717,
	"./big-arrow-red.svg": 3809,
	"./big-arrow.svg": 3659,
	"./check-blue.svg": 3190,
	"./check-dark.svg": 3570,
	"./check.svg": 2497,
	"./cross.svg": 9973,
	"./done.svg": 6903,
	"./download.svg": 1303,
	"./menu.svg": 2434,
	"./more.svg": 916,
	"./play.svg": 757,
	"./plus.svg": 4491,
	"./setting.svg": 9941,
	"./waves.svg": 5931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;